import { render } from "./TemplateEditor.vue?vue&type=template&id=783ddf04&scoped=true&ts=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"

import "./TemplateEditor.vue?vue&type=style&index=0&id=783ddf04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783ddf04"]])

export default __exports__